import { useNotifierAction } from "@lib/notification";
import { getPresignedUrl } from "@services/app";
import { useS3Uploader } from "use-s3-uploader";

const DEFAULT_PATH = `library/`;

const useUploader = (props, ref) => {
  const { path, onUploadStart, onProgress, onError, onFinish } = props;

  const { enqueueSnackbar } = useNotifierAction();

  const getSignedUrl = (file, callback) => {
    const params = {
      fileName: file.name,
      fileSize: file.size,
      contentType: file.type,
      cloud_front: true,
      path: path || DEFAULT_PATH,
    };

    new Promise(function (resolve, reject) {
      getImageWidthHeight(file, resolve);
    }).then(function (result) {
      let data = Object.assign(params, result);
      getPresignedUrl(data)
        .then((res) => {
          res = res.data;
          callback(res.data);
        })
        .catch(function (err) {
          enqueueSnackbar({
            message: "Upload failed.",
            options: {
              key: new Date().getTime() + Math.random(),
              variant: "error",
            },
          });
        });
    });
  };

  const getImageWidthHeight = (file, resolve) => {
    let data = {
      width: 0,
      height: 0,
    };

    //读取图片数据
    const reader = new FileReader();
    reader.onload = function (e) {
      let result = e.target.result;
      //加载图片获取图片真实宽度和高度
      const image = new Image();
      image.onload = function () {
        data.width = image.width;
        data.height = image.height;
        resolve(data);
      };
      image.src = result;
    };
    reader.readAsDataURL(file);
  };

  useS3Uploader(
    {
      getSignedUrl: getSignedUrl,
      onUploadStart: onUploadStart,
      onProgress: onProgress,
      onError: onError,
      onFinish: onFinish,
      accept: "image/*",
      uploadRequestHeaders: {
        "x-amz-acl": "public-read",
      },
      contentDisposition: "auto",
    },
    ref
  );
};

export default useUploader;
